import { render, staticRenderFns } from "./_editwith.vue?vue&type=template&id=2b65ddf6&scoped=true"
import script from "./_editwith.vue?vue&type=script&lang=js"
export * from "./_editwith.vue?vue&type=script&lang=js"
import style0 from "./_editwith.vue?vue&type=style&index=0&id=2b65ddf6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b65ddf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b65ddf6')) {
      api.createRecord('2b65ddf6', component.options)
    } else {
      api.reload('2b65ddf6', component.options)
    }
    module.hot.accept("./_editwith.vue?vue&type=template&id=2b65ddf6&scoped=true", function () {
      api.rerender('2b65ddf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/_editwith.vue"
export default component.exports